import {
  RequirementDefinitionTransitionScope,
  RequirementDefinitionTransitionStrategy
} from "@wingspanhq/wingspan-api-sdk";

export const getTransitionCurrentValue = (
  scope: RequirementDefinitionTransitionScope,
  transitionMethod: RequirementDefinitionTransitionStrategy
): { primary: string; secondary?: string; disabled?: boolean } => {
  if (scope === RequirementDefinitionTransitionScope.NEW_ONLY) {
    return { disabled: true, primary: "—" };
  }

  if (scope === RequirementDefinitionTransitionScope.ALL) {
    return transitionMethod === RequirementDefinitionTransitionStrategy.RENEWAL
      ? {
          disabled: true,
          primary: "—",
          secondary: "Complete requirements valid until expiration"
        }
      : {
          disabled: true,
          primary: "—",
          secondary: "None (all transitioning to new)"
        };
  }

  return transitionMethod === RequirementDefinitionTransitionStrategy.RENEWAL
    ? {
        disabled: true,
        primary: "—",
        secondary: "Complete requirements remain valid"
      }
    : {
        disabled: true,
        primary: "—",
        secondary: "Incomplete reset immediately"
      };
};

export const getTransitionNewValue = (
  scope: RequirementDefinitionTransitionScope,
  transitionMethod: RequirementDefinitionTransitionStrategy,
  renewalDeadlineDays: number
): { primary: string; secondary?: string } => {
  if (scope === RequirementDefinitionTransitionScope.NEW_ONLY) {
    return { primary: "New assignments only" };
  }

  return transitionMethod === RequirementDefinitionTransitionStrategy.RENEWAL
    ? {
        primary: `Effective: ${renewalDeadlineDays}-day deadline`,
        secondary:
          scope === RequirementDefinitionTransitionScope.ALL
            ? "Complete by effective date"
            : "Incomplete until satisfied"
      }
    : {
        primary: "Effective: immediately",
        secondary: "Incomplete immediately until satisfied"
      };
};
